<template>
  <a-layout>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      keep-source
      :edit-rules="editRules"
      :edit-config="editConfig">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="print.name" title="business.label.printName"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="mac" title="business.label.mac"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="host" title="business.label.host"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="ip" title="business.label.ip"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="printer" title="business.label.printer"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>

<script>
import { findAll, saveAll } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'

export default {
  name: 'PrintConfig',
  data() {
    return {
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      data: [],
      print: null,
      contentSize: 0,
      page: 1,
      size: 15,
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.8075),// 表格竖向滚动条
      editConfig: { trigger: 'click', mode: 'cell', showStatus: true },
      editRules: {
        mac: [
          { required: true, type: 'string', message: 'MAC地址不能为空' }
        ],
        host: [
          { required: true, type: 'string', message: '打印服务端不能为空' }
        ],
        ip: [
          { required: true, type: 'string', message: '服务端IP不能为空' }
        ],
        printer: [
          { required: true, type: 'string', message: '打印机名称不能为空' }
        ]
      }
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.refresh()
    },
    add() {
      const record = {
        id: null,
        mac: null,
        host: null,
        ip: null,
        printer: null,
        print: this.print,
        warehouse: this.warehouse
      }
      this.data.push(record)
    },
    refresh(print) {
      if (print !== null && print !== undefined) {
        this.print = Object.assign({}, print)
      }
      if (this.print === null || this.print === undefined) {
        return this.$message.warning('请先选择仓库')
      }
      this.loading = true
      findAll('printConfigFactory', { 'print.id': this.print.id }, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
        }
      }).finally(() => this.loading = false)
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      const saveData = this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords())
      if (saveData.length > 0) {
        this.loading = true
        saveAll('printConfigPersister', saveData).then(res => {
          if (res.success) {
            this.refresh()
            this.$message.success('保存成功')
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    },
    resetPage() {
      this.page = 1
    }
  }
}
</script>